var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "ui-select-option",
      class: _vm.classes,
      style: _vm.selectedStyle,
    },
    [
      _vm._t("default", function () {
        return [
          _vm.multiple
            ? _c(
                "div",
                {
                  staticClass: "ui-select-option-checkbox",
                  style: _vm.selectedStyle,
                },
                [
                  _vm.selected
                    ? _c("UiIcon", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9.984 17.016l9-9-1.406-1.453-7.594 7.594-3.563-3.563L5.016\n          12zm9-14.016C20.11 3 21 3.938 21 5.016v13.97C21 20.062 20.11 21 18.984\n          21H5.014C3.89 21 3 20.064 3 18.986V5.015C3 3.94 3.89 3 5.014 3h13.97z",
                              },
                            }),
                          ]
                        ),
                      ])
                    : _c("UiIcon", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M18.984 3C20.062 3 21 3.938 21 5.016v13.97C21 20.062 20.062\n          21 18.984 21H5.014C3.938 21 3 20.064 3 18.986V5.015C3 3.94 3.936\n          3 5.014 3h13.97zm0 2.016H5.014v13.97h13.97V5.015z",
                              },
                            }),
                          ]
                        ),
                      ]),
                ],
                1
              )
            : _vm._e(),
          _vm.type === "basic"
            ? _c("div", { staticClass: "ui-select-option-basic" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.option[_vm.keys.label] || _vm.option) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm.type === "image"
            ? _c("div", { staticClass: "ui-select-option-image" }, [
                _c("div", {
                  staticClass: "ui-select-option-image-object",
                  style: _vm.imageStyle,
                }),
                _c("div", { staticClass: "ui-select-option-image-text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.option[_vm.keys.label]) +
                      "\n      "
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }